export default __webpack_public_path__ + "static/media/update.8d9d79d5.svg";